<div fxLayoutAlign="center center"><h2>Summary / Confirmation</h2></div>
<div fxLayoutAlign="center center">
    <div fxLayout="column" fxFlex="60" fxFlex.md="70" fxFlex.sm="80" fxFlex.xs="95">
        <div><b>Faculty:</b> {{quotationDetail.facultyName}}</div>
        <div><b>Degree:</b> {{degreeFullName}}</div>
        <div><b>Year Level:</b> {{quotationDetail.yearLevelId}}</div>
        <div [fxShow]="coreModules.length > 0">
            <p><i>Compulsory Modules</i></p>
            <mat-table [dataSource]="coreModules">
                <ng-container matColumnDef="moduleCode">
                    <mat-cell fxFlex="100px" fxHide.lt-sm *matCellDef="let module"> {{module.moduleCode}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="moduleName">
                    <mat-cell fxFlex *matCellDef="let module"> {{module.moduleName}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="moduleCost">
                    <mat-cell fxFlex="100px" fxFlex.sm="80px" [fxShow]="chargeByModule" *matCellDef="let module"> {{module.moduleCost | currency : "R "}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="moduleCredits">
                    <mat-cell fxFlex="50px"  fxFlex.sm="0 0 30px" fxLayoutAlign="end center" *matCellDef="let module"> {{module.moduleCredits}} </mat-cell>
                </ng-container>
                <mat-row *matRowDef="let module; columns: displayedModuleColumns;"></mat-row>
            </mat-table>
        </div>
        <div [fxShow]="electiveModules.length > 0">
            <p><i>Elective Modules</i></p>
            <mat-table [dataSource]="electiveModules">
                <ng-container matColumnDef="moduleCode">
                    <mat-cell fxFlex="120px" fxHide.lt-sm *matCellDef="let module"> {{module.moduleCode}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="moduleName">
                    <mat-cell fxFlex *matCellDef="let module"> {{module.moduleName}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="moduleCost">
                    <mat-cell fxFlex="100px" fxFlex.sm="80px" [fxShow]="chargeByModule" *matCellDef="let module"> {{module.moduleCost | currency : "R "}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="moduleCredits">
                    <mat-cell fxFlex="50px" fxFlex.sm="0 0 30px" fxLayoutAlign="end center" *matCellDef="let module"> {{module.moduleCredits}} </mat-cell>
                </ng-container>
                <mat-row *matRowDef="let module; columns: displayedModuleColumns;"></mat-row>
            </mat-table>
        </div>
        <div>&nbsp;</div>
        <div>
            <mat-table [dataSource]="subtotalDataSource">
                <ng-container matColumnDef="description">
                    <mat-cell class="mat-table-totals" fxFlex *matCellDef="let subTotal"> {{subTotal.description}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="amount">
                    <mat-cell fxFlex="100px" fxFlex.sm="80px" *matCellDef="let subTotal"> {{subTotal.amount | currency : "R "}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="credits">
                    <mat-cell fxFlex="50px"  fxFlex.sm="0 0 30px" fxLayoutAlign="end center" *matCellDef="let subTotal"> {{subTotal.credits}} </mat-cell>
                </ng-container>
                <mat-row *matRowDef="let subTotal; columns: displayedSubTotalColumn;"></mat-row>
            </mat-table>
            <mat-table [dataSource]="totalDataSource">
                <ng-container matColumnDef="description">
                    <mat-cell class="mat-table-totals" fxFlex *matCellDef="let total"> <b>{{total.description}}</b> </mat-cell>
                </ng-container>
                <ng-container matColumnDef="amount">
                    <mat-cell fxFlex="100px" fxFlex.sm="80px" *matCellDef="let total"> <b>{{total.amount | currency : "R "}}</b> </mat-cell>
                </ng-container>
                <ng-container matColumnDef="credits">
                    <mat-cell fxFlex="50px"  fxFlex.sm="0 0 30px" fxLayoutAlign="end center" *matCellDef="let total"> {{total.credits}} </mat-cell>
                </ng-container>
                <mat-row *matRowDef="let total; columns: displayedSubTotalColumn;"></mat-row>
            </mat-table>
        </div>
        <div>
            <div class="container-group-spacing">
                <mat-expansion-panel [expanded]="!showResSelect" class="mat-elevation-z0">
                    <p><b>Note: </b>Accommodation is <b><u>not included</u></b> in summary of Programme Selection</p>
                </mat-expansion-panel>
            </div>
            <div class="container-group-spacing expansion-panel-checkbox-container">
                <mat-checkbox [checked]="checked" (change)="toggleResidenceSelection(false)">Include University Residence</mat-checkbox>
            </div>
            <mat-expansion-panel [expanded]="showResSelect" class="mat-elevation-z0">
                <div fxLayout="column">
                    <mat-table [dataSource]="residences">
                        <ng-container matColumnDef="roomTypeId">
                                <mat-cell fxHide fxLayoutAlign="center center" *matCellDef="let res"> {{res.roomTypeId}} </mat-cell>
                            </ng-container>
                        <ng-container  matColumnDef="resSelect">
                            <mat-cell style="visibility: hidden" fxFlex="20px" fxLayoutAlign="start center" *matCellDef="let res">
                                <mat-radio-button (change)="resSelectionChange(res)" [value]="res.selected" [checked]="res.selected == true"></mat-radio-button>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="roomTypeName">
                            <mat-cell fxFlex *matCellDef="let res"> {{res.roomTypeName}} &nbsp; 
                                <mat-label class="res-mat-label-tooltop" [matTooltip]="res.toolTip" matTooltipPosition="left">
                                    <mat-icon>info</mat-icon>
                                </mat-label>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="maxPrice">
                            <mat-cell  fxFlex="100px" fxFlex.sm="80px" *matCellDef="let res"> {{res.maxPrice | currency : "R "}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="placeHolder">
                            <mat-cell fxFlex="50px"  fxFlex.sm="0 0 30px" fxLayoutAlign="end center" *matCellDef="let res"> </mat-cell>
                        </ng-container>
                        <mat-row *matRowDef="let res; columns: displayedResColumns;"></mat-row>
                    </mat-table>
                </div>
                <div [fxShow]="!canIncludeRes">There is no accommodation currently available.</div>
            </mat-expansion-panel>
            <div>
                <div fxFlex="row" class="container-group-spacing navigation-container">
                    <div fxFlex="50" fxLayoutAlign="start center">
                        <button mat-button [routerLink]="['/default', {outlets: {'main': ['modules']}}]" class="navigation-button navigation-button-back">Back</button>
                    </div>
                    <div fxFlex="50" fxLayoutAlign="end center">
                        <button mat-button (click)="proceed()" class="navigation-button navigation-button-proceed">Proceed</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>